// Client-side guidance for the password rule. The server enforces the real rule (and a much longer
// list of common passwords); this only tells the user early what is wrong.
export const PASSWORD_MIN_LENGTH = 10;

const SOME_COMMON = [
  'password', 'passw0rd', 'wagwoord', '1234567890', '0123456789', 'qwertyuiop', 'qwerty123', 'welcome123',
  'letmein123', 'admin12345', 'iloveyou12', 'abc1234567', 'password1', 'password123', 'wagwoord123', '1q2w3e4r5t',
];

export interface PasswordContext {
  email?: string;
  firstName?: string;
  lastName?: string;
}

/** What is wrong with this password, in Afrikaans; null when it passes the guidance. */
export function passwordProblem(password: string, ctx: PasswordContext = {}): string | null {
  if (!password) {
    return 'Wagwoord is verpligtend.';
  }
  if (password.length < PASSWORD_MIN_LENGTH) {
    return `Gebruik minstens ${PASSWORD_MIN_LENGTH} karakters.`;
  }
  const lower = password.toLowerCase();
  if (SOME_COMMON.some((common) => lower.includes(common)) || /^(.)\1+$/.test(password)) {
    return 'Hierdie wagwoord is te algemeen. Kies iets wat moeiliker is om te raai.';
  }
  const emailName = (ctx.email || '').split('@')[0].toLowerCase();
  if (emailName.length >= 3 && lower.includes(emailName)) {
    return 'Die wagwoord mag nie jou e-pos se naam bevat nie.';
  }
  for (const name of [ctx.firstName, ctx.lastName]) {
    const n = (name || '').trim().toLowerCase();
    if (n.length >= 3 && lower.includes(n)) {
      return 'Die wagwoord mag nie jou naam bevat nie.';
    }
  }
  return null;
}

/** 0 = nothing typed, 1 = too weak, 2 = acceptable, 3 = good, 4 = strong. Length based, on purpose simple. */
export function passwordStrength(password: string, ctx: PasswordContext = {}): number {
  if (!password) {
    return 0;
  }
  if (passwordProblem(password, ctx)) {
    return 1;
  }
  if (password.length >= 16) {
    return 4;
  }
  return password.length >= 12 ? 3 : 2;
}

export const STRENGTH_LABELS = ['', 'Te swak', 'Aanvaarbaar', 'Goed', 'Sterk'];
export const STRENGTH_COLORS = ['grey', 'error', 'warning', 'success', 'success'];

/** The server's message when it sent one ({message}), else the fallback. */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function serverMessage(error: any, fallback: string): string {
  const data = error?.response?.data;
  if (data && typeof data === 'object' && typeof data.message === 'string' && data.message) {
    return data.message;
  }
  if (typeof data === 'string' && data) {
    return data;
  }
  return fallback;
}
